module.exports = __webpack_public_path__ + "static/chocolate_handmade-7067a639b30ebb8430882ad96db85065.jpg";